import { NoteMarkType } from '~/services/api/enums';
import { IFormValues } from '~/ui/components/reusable/Notes/NoteForm/types';

const initialValues: IFormValues = {
  content: '',
  isTelephoneConversation: false,
  showReminder: false,
  reminderDate: '',
  notifyHealthManager: false,
  isSentForTriage: false,
  issueName: '',
  isHighPriority: false,
  markTypeId: NoteMarkType.None,
};

export default initialValues;
